// apps/client/src/ui/kit/RoundButton.tsx
import type { ReactNode } from 'react';
export function RoundButton(p: { label: string; green?: boolean; size?: number; badge?: boolean; onClick?: () => void; onPointerDown?: () => void; onPointerUp?: () => void; children?: ReactNode }) {
  return (
    <button type="button" aria-label={p.label} title={p.label} className={`round-btn hit${p.green ? ' green' : ''}`}
      style={p.size ? { width: p.size, height: p.size } : undefined} onClick={p.onClick} onPointerDown={p.onPointerDown} onPointerUp={p.onPointerUp}>
      {p.children}
      {p.badge && <span aria-hidden="true" style={{ position: 'absolute', top: 4, right: 4, width: 10, height: 10, borderRadius: 5, background: 'var(--flag-500)' }} />}
    </button>
  );
}
